import React from "react";
import styles from "./BuildBadge.module.css";

// Shows the deployed commit SHA (baked in at CI build time via
// REACT_APP_GIT_COMMIT) so it's obvious which build is live on a given
// environment. Renders nothing locally, where the env var is unset.
function BuildBadge() {
  const commit = process.env.REACT_APP_GIT_COMMIT;
  if (!commit) return null;

  return <div className={styles.badge}>{commit}</div>;
}

export default BuildBadge;
